import {
  Stack,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';

export const TerraformBashToggle = ({
  text,
  connectMethod,
  setConnectMethod,
}: {
  text: string;
  connectMethod: 'terraform' | 'bash';
  setConnectMethod: (connectMethod: 'terraform' | 'bash') => void;
}) => {
  return (
    <Stack paddingX='40px' direction='row' justifyContent='space-between'>
      <Typography width='540px' variant='body1'>
        {text}
      </Typography>
      <ToggleButtonGroup
        exclusive
        value={connectMethod}
        onChange={(_, value) => {
          if (value === null) {
            return;
          }
          setConnectMethod(value);
        }}
      >
        <ToggleButton value='terraform'>Terraform</ToggleButton>
        <ToggleButton value='bash'>Bash</ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
};
